import { cn } from '~/utils';

type RaffleLogoProps = {
  className?: string;
  dark?: boolean;
};

export const RaffleLogo = ({ className, dark = false }: RaffleLogoProps) => (
  <div className={cn('flex h-auto w-8 items-center justify-center', className)}>
    {dark ? (
      <svg
        width="22"
        height="26"
        viewBox="0 0 22 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.27295 21.9026V8.02124L6.25803 9.28894L5.27295 11.1001V24.3746L9.27295 21.9026Z"
          fill="url(#paint0_linear_5563_23931)"
        />
        <path
          d="M9.07308 8.37603L10.1297 8.65027C9.99974 9.1039 9.92905 9.61542 9.91862 10.1798L9.91726 10.3276V22.4949L5.84381 25.1265L5.27246 24.8338V23.5749L5.7822 23.8362L8.8262 21.8697L8.8264 10.3169L8.82791 10.1583C8.83988 9.5109 8.92301 8.91461 9.07308 8.37603ZM21.8931 6.8129L21.9846 7.01453L18.5453 9.14857C18.354 9.17713 18.1722 9.2043 17.9997 9.23006L18 8.09771C18.0054 8.09717 18.0108 8.09664 18.0162 8.09613L18.0406 8.11361L18.0797 8.09017L20.5498 6.58115L20.5391 6.56091C19.3246 4.31943 17.6266 2.83696 15.521 2.16537L15.5209 0.991211C18.3026 1.76875 20.4827 3.76392 21.8931 6.8129Z"
          fill="#F9FCFF"
        />
        <path
          d="M1.09091 25.8926L0 25.8927V12.9592C0 7.23023 3.56574 2.75806 9.39058 2.75806C13.4745 2.75806 16.6214 4.94456 18.4549 8.94695L18.5455 9.14858L13.2359 11.6972C12.3451 9.67493 11.1952 8.85853 9.39058 8.85853C7.09975 8.85853 5.89096 10.3194 5.84531 12.8114L5.84397 12.9592V25.1265L4.72727 25.8927V24.5387L4.75291 24.5212L4.75311 12.9486L4.7546 12.7901C4.81179 9.6675 6.51258 7.73072 9.39058 7.73072C11.2741 7.73072 12.6388 8.49498 13.6502 10.1211L13.7133 10.2246L17.0624 8.61688L17.0478 8.59007C15.371 5.53321 12.7892 3.92113 9.4993 3.88645L9.39058 3.88588C4.43319 3.88588 1.15692 7.54017 1.0919 12.7993L1.09091 12.9592V25.8926Z"
          fill="#F9FCFF"
        />
        <defs>
          <linearGradient
            id="paint0_linear_5563_23931"
            x1="5.00024"
            y1="8"
            x2="10.0002"
            y2="25.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#EF92F7" />
            <stop offset="1" stopColor="#FF385C" />
          </linearGradient>
        </defs>
      </svg>
    ) : (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="26"
        viewBox="0 0 22 26"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.27246 21.9028V8.02148L6.25755 9.28918L5.27246 11.1003V24.3749L9.27246 21.9028Z"
          fill="#02E05B"
        />
        <path
          d="M9.07308 8.37603L10.1297 8.65027C9.99974 9.1039 9.92905 9.61542 9.91862 10.1798L9.91726 10.3276V22.4949L5.84381 25.1265L5.27246 24.8338V23.5749L5.7822 23.8362L8.8262 21.8697L8.8264 10.3169L8.82791 10.1583C8.83988 9.5109 8.92301 8.91461 9.07308 8.37603ZM21.8931 6.8129L21.9846 7.01453L18.5453 9.14857C18.354 9.17713 18.1722 9.2043 17.9997 9.23006L18 8.09771C18.0054 8.09717 18.0108 8.09664 18.0162 8.09613L18.0406 8.11361L18.0797 8.09017L20.5498 6.58115L20.5391 6.56091C19.3246 4.31943 17.6266 2.83696 15.521 2.16537L15.5209 0.991211C18.3026 1.76875 20.4827 3.76392 21.8931 6.8129Z"
          fill="#024C64"
        />
        <path
          d="M1.09091 25.8924L0 25.8924V12.959C0 7.22998 3.56574 2.75781 9.39058 2.75781C13.4745 2.75781 16.6214 4.94431 18.4549 8.9467L18.5455 9.14834L13.2359 11.6969C12.3451 9.67469 11.1952 8.85829 9.39058 8.85829C7.09975 8.85829 5.89096 10.3191 5.84531 12.8112L5.84397 12.959V25.1262L4.72727 25.8924V24.5385L4.75291 24.521L4.75311 12.9484L4.7546 12.7898C4.81179 9.66725 6.51258 7.73047 9.39058 7.73047C11.2741 7.73047 12.6388 8.49473 13.6502 10.1209L13.7133 10.2243L17.0624 8.61663L17.0478 8.58982C15.371 5.53297 12.7892 3.92089 9.4993 3.8862L9.39058 3.88563C4.43319 3.88563 1.15692 7.53993 1.0919 12.7991L1.09091 12.959V25.8924Z"
          fill="#024C64"
        />
      </svg>
    )}
  </div>
);

export const RaffleAppLogo = ({
  className,
  color = 'white', // Default color if no color prop is provided
}: {
  className?: string;
  color?: string; // Allow any color as a string
}) => (
  <div
    className={cn('flex h-16 w-16 items-center', `!text-${color}`, className)}
  >
    <svg
      width="256"
      height="256"
      viewBox="0 0 256 256"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="256" height="256" rx="40" fill="#1D1D23" />
      <g clipPath="url(#clip0_1525_9657)">
        <path
          d="M118.799 88.9754L126.466 90.5088C126.466 94.3423 126.466 98.1758 126.466 102.776V104.309V199.38L94.265 219.314L89.6648 216.247V205.514L94.265 208.58L118.799 193.246V104.309V102.776C118.895 97.7994 118.799 93.5756 118.799 88.9754ZM224.604 75.9416L226.904 79.7751L195.469 95.109C193.942 95.3286 192.245 94.9111 190.869 95.109V87.442C190.826 87.446 190.912 87.4379 190.869 87.442H192.402L214.637 76.7083C200.836 55.2407 183.202 42.9736 170.935 39.9068V30.7064C193.14 36.6837 210.036 53.7073 224.604 75.9416Z"
          fill="#F7F8FD"
        />
        <path
          d="M57.4626 223.912H48.2622V124.241C48.2622 80.1931 77.1635 46.038 123.399 46.038C155.815 46.038 180.915 62.8003 195.468 93.5733V95.1067L154.067 115.041C146.996 99.4925 137.723 93.5733 123.399 93.5733C105.215 93.5733 94.6264 103.547 94.2641 122.708V124.241V219.312L86.5971 223.912V213.178V124.241V122.708C87.0512 98.6995 100.554 84.3729 123.399 84.3729C138.349 84.3729 149.105 90.2708 157.133 102.774L183.201 90.5065C169.891 67.0034 149.513 55.5051 123.399 55.2384C84.0489 55.2384 57.9788 82.2719 57.4626 122.708V124.241V223.912Z"
          fill="#F7F8FD"
        />
      </g>
      <defs>
        <clipPath id="clip0_1525_9657">
          <rect
            width="179.407"
            height="193.208"
            fill="white"
            transform="translate(48.2627 30.7065)"
          />
        </clipPath>
      </defs>
    </svg>
  </div>
);

export const RaffleAppLogoLight = ({ className }: { className?: string }) => (
  <div className={cn('flex h-24 w-24 items-center', className)}>
    <svg
      width="128"
      height="128"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="127"
        height="127"
        rx="19.4541"
        fill="url(#paint0_linear_4256_147)"
      />
      <rect
        x="0.5"
        y="0.5"
        width="127"
        height="127"
        rx="19.4541"
        stroke="#DFE5EF"
      />
      <g clipPath="url(#clip0_4256_147)">
        <path
          d="M62.1768 50.2121L64.8363 50.744C64.8363 52.0737 64.8363 53.4035 64.8363 54.9991V55.531V88.5085L53.6665 95.4231L52.0708 94.3593V90.636L53.6665 91.6998L62.1768 86.3809V55.531V54.9991C62.2099 53.2729 62.1768 51.8078 62.1768 50.2121ZM98.8775 45.691L99.6753 47.0207L88.7715 52.3397C88.2419 52.4158 87.6533 52.271 87.1758 52.3397V49.6802C87.161 49.6816 87.1908 49.6788 87.1758 49.6802H87.7077L95.4201 45.957C90.6331 38.5104 84.5163 34.2553 80.2612 33.1915V30.0001C87.9636 32.0735 93.8245 37.9785 98.8775 45.691Z"
          fill="#12151F"
        />
        <path
          d="M40.9008 97.0179H37.7095V62.4448C37.7095 47.1657 47.7346 35.3182 63.7723 35.3182C75.0168 35.3182 83.7231 41.1326 88.7713 51.8069V52.3388L74.4101 59.2535C71.9576 53.8602 68.7408 51.8069 63.7723 51.8069C57.4649 51.8069 53.792 55.2666 53.6663 61.9129V62.4448V95.4222L51.0068 97.0179V93.2947V62.4448V61.9129C51.1643 53.5851 55.8482 48.6156 63.7723 48.6156C68.9581 48.6156 72.6892 50.6614 75.4739 54.9983L84.5161 50.7432C79.8992 42.5906 72.8305 38.6021 63.7723 38.5096C50.1229 38.5096 41.0799 47.8868 40.9008 61.9129V62.4448V97.0179Z"
          fill="#12151F"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_4256_147"
          x1="64"
          y1="0"
          x2="64"
          y2="128"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7F8FD" />
          <stop offset="1" stopColor="#D6DCE7" />
        </linearGradient>
        <clipPath id="clip0_4256_147">
          <rect
            width="62.2316"
            height="67.0186"
            fill="white"
            transform="translate(37.7095 30)"
          />
        </clipPath>
      </defs>
    </svg>
  </div>
);

export const RaffleAppLogoDark = ({ className }: { className?: string }) => (
  <div className={cn('flex h-20 w-20 items-center bg-transparent', className)}>
    <svg
      width="256"
      height="256"
      viewBox="0 0 256 256"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.25"
        y="0.25"
        width="255.5"
        height="255.5"
        rx="40.75"
        fill="url(#paint0_linear_4265_241)"
      />
      <rect
        x="0.25"
        y="0.25"
        width="255.5"
        height="255.5"
        rx="40.75"
        stroke="url(#paint1_linear_4265_241)"
        strokeWidth="0.5"
      />
      <g clipPath="url(#clip0_4265_241)" filter="url(#filter0_d_4265_241)">
        <path
          d="M121.566 94.5933L128.095 95.8991C128.095 99.1635 128.095 102.428 128.095 106.345V107.651V188.609L100.673 205.584L96.7561 202.972V193.832L100.673 196.443L121.566 183.385V107.651V106.345C121.647 102.107 121.566 98.5106 121.566 94.5933ZM211.664 83.4943L213.622 86.7587L186.854 99.8164C185.554 100.003 184.109 99.6478 182.937 99.8164V93.2876C182.9 93.291 182.974 93.284 182.937 93.2876H184.242L203.176 84.1472C191.424 65.8665 176.408 55.4203 165.962 52.8088V44.9742C184.871 50.0642 199.259 64.5607 211.664 83.4943Z"
          fill="#D6DCE7"
        />
        <path
          d="M69.3344 209.499H61.4998V124.624C61.4998 87.1146 86.1107 58.0298 125.482 58.0298C153.087 58.0298 174.46 72.3038 186.853 98.5086V99.8143L151.598 116.789C145.577 103.549 137.68 98.5086 125.482 98.5086C109.998 98.5086 100.981 107.002 100.673 123.318V124.624V205.581L94.1439 209.499V200.358V124.624V123.318C94.5306 102.874 106.029 90.674 125.482 90.674C138.213 90.674 147.373 95.6963 154.209 106.343L176.407 95.897C165.073 75.8829 147.72 66.0915 125.482 65.8644C91.974 65.8644 69.7739 88.8848 69.3344 123.318V124.624V209.499Z"
          fill="#D6DCE7"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_4265_241"
          x="51.5"
          y="37.4742"
          width="172.775"
          height="184.527"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.5" />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0705882 0 0 0 0 0.0823529 0 0 0 0 0.121569 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4265_241"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4265_241"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_4265_241"
          x1="128"
          y1="0"
          x2="128"
          y2="256"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1A1E2B" />
          <stop offset="1" stopColor="#12151F" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_4265_241"
          x1="128"
          y1="0"
          x2="128"
          y2="256"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#475074" />
          <stop offset="1" stopColor="#242B45" />
        </linearGradient>
        <clipPath id="clip0_4265_241">
          <rect
            width="152.775"
            height="164.527"
            fill="white"
            transform="translate(61.5 44.9742)"
          />
        </clipPath>
      </defs>
    </svg>
  </div>
);

export const RaffleLogoText = ({ className }: { className?: string }) => (
  <div className={cn('flex h-full w-16 items-center text-white', className)}>
    <svg viewBox="0 0 500 168" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1525_9678)">
        <path
          d="M445.906 50.6227C462.973 50.6227 476.255 55.6866 485.753 65.8147C495.251 75.9428 500 89.8689 500 107.593C500 109.678 499.927 111.652 499.778 113.514C499.638 115.259 499.565 116.317 499.556 116.688L499.554 116.753H421.194C421.343 120.328 422.197 123.642 423.755 126.695C425.314 129.748 427.318 132.392 429.766 134.626C432.215 136.86 435.071 138.61 438.337 139.876C441.6 141.142 445.09 141.776 448.799 141.776C451.598 141.776 454.151 141.524 456.46 141.02L469.437 163.557C468.621 163.87 467.791 164.168 466.941 164.452C461.377 166.314 455.255 167.245 448.577 167.245C441.008 167.245 433.81 165.941 426.983 163.335C420.157 160.728 414.146 156.893 408.952 151.829C403.757 146.765 399.638 140.584 396.596 133.286C393.554 125.988 392.033 117.721 392.033 108.487C392.033 99.6992 393.517 91.7308 396.485 84.5816C399.454 77.4324 403.423 71.3629 408.395 66.3733C413.366 61.3838 419.117 57.5113 425.646 54.7559C432.178 52.0004 438.931 50.6227 445.906 50.6227ZM125.114 50.6227C133.722 50.6227 141.068 51.7769 147.153 54.0856C153.238 56.3942 158.172 59.4474 161.957 63.2454C165.741 67.0436 168.487 71.4745 170.193 76.5386C171.8 81.3049 172.65 86.2689 172.745 91.4308L172.753 92.401V146.467L172.76 147.593C172.793 150.24 172.939 153.03 173.199 155.962C173.476 159.09 173.753 161.601 174.03 163.497L174.089 163.893H146.93L146.862 163.54C146.594 162.086 146.356 160.155 146.151 157.749C145.928 155.143 145.817 152.797 145.817 150.712C142.997 155.031 138.953 158.829 133.685 162.106C128.416 165.383 121.701 167.021 113.538 167.021C107.75 167.021 102.519 166.09 97.8439 164.229C93.169 162.367 89.1991 159.909 85.9341 156.856C82.669 153.803 80.1832 150.302 78.4765 146.355C76.7698 142.408 75.9165 138.275 75.9165 133.956C75.9165 129.041 76.7698 124.684 78.4765 120.886C80.1832 117.088 82.5207 113.774 85.4889 110.944C88.4571 108.114 91.9075 105.88 95.8403 104.242C99.4707 102.73 103.386 101.598 107.585 100.847L108.641 100.667L135.577 96.6458L136.037 96.5751C138.906 96.1047 140.905 95.1974 142.033 93.8532C143.22 92.4382 143.814 90.7627 143.814 88.8263C143.814 84.9539 142.292 81.6027 139.25 78.7727C136.208 75.9428 131.57 74.5279 125.337 74.5279C120.529 74.5279 116.546 75.4968 113.387 77.4346L99.3998 56.6416C101.309 55.6209 103.35 54.6946 105.524 53.8621C111.164 51.7024 117.694 50.6227 125.114 50.6227ZM309.483 0.57795C312.6 0.57795 315.531 0.801363 318.276 1.24819C320.851 1.66709 322.741 2.15145 323.943 2.70126L324.176 2.81209V27.8344C323.433 27.5366 322.32 27.2759 320.837 27.0524C319.354 26.8292 317.349 26.7173 314.826 26.7173C313.195 26.7173 311.487 26.9408 309.707 27.3876C307.925 27.8344 306.255 28.6163 304.697 29.7334C303.138 30.8504 301.877 32.3771 300.912 34.3135C300.008 36.1288 299.527 38.4675 299.471 41.33L299.466 41.9095V53.9739H343.99V2.14185H373.596V124.523H343.99V79.443H299.466V163.893H269.858V79.443H227.561V163.893H197.731V79.443H179.477V53.9739H197.731V41.4627C197.731 35.2071 198.659 29.5846 200.514 24.595C202.369 19.6054 205.041 15.3233 208.528 11.7486C212.017 8.17401 216.209 5.41857 221.107 3.48233C226.004 1.54608 231.494 0.57795 237.579 0.57795C240.697 0.57795 243.628 0.801363 246.372 1.24819C248.946 1.66709 250.835 2.15145 252.04 2.70126L252.272 2.81209V27.8344C251.529 27.5366 250.416 27.2759 248.933 27.0524C247.448 26.8292 245.446 26.7173 242.923 26.7173C241.289 26.7173 239.584 26.9408 237.801 27.3876C236.021 27.8344 234.351 28.6163 232.793 29.7334C231.234 30.8504 229.973 32.3771 229.008 34.3135C228.105 36.1288 227.623 38.4675 227.567 41.33L227.561 41.9095V53.9739H269.858V41.4627C269.858 28.9514 273.458 19.0096 280.655 11.6369C287.854 4.26427 297.462 0.57795 309.483 0.57795ZM143.814 113.757L119.104 118.317C115.245 118.913 112.017 120.29 109.42 122.45C106.823 124.61 105.524 127.849 105.524 132.169C105.524 135.445 106.711 138.387 109.086 140.993C111.46 143.6 115.022 144.903 119.771 144.903C122.888 144.903 125.893 144.494 128.787 143.675C131.681 142.855 134.241 141.44 136.467 139.43C138.693 137.419 140.474 134.812 141.81 131.61C143.079 128.568 143.745 124.753 143.809 120.165L143.814 119.434V113.757ZM446.349 74.7512C442.492 74.7512 439.077 75.4215 436.111 76.7621C433.142 78.1024 430.619 79.8153 428.542 81.9006C426.464 83.9858 424.868 86.2944 423.755 88.8263C422.734 91.1474 422.119 93.4685 421.91 95.7894L421.862 96.4225H470.839C470.69 93.7414 470.134 91.0978 469.167 88.4912C468.203 85.8848 466.72 83.5761 464.715 81.5655C462.713 79.5547 460.19 77.9163 457.146 76.6502C454.105 75.3844 450.506 74.7512 446.349 74.7512Z"
          fill="currentColor"
        />
        <path
          d="M49.0448 51.7593C70.3745 51.7593 86.8096 62.7914 96.3856 82.9856L96.8586 84.0029L69.128 96.8619C64.4757 86.6587 58.4697 82.5394 49.0448 82.5394C37.0803 82.5394 30.7672 89.9101 30.5287 102.484L30.5218 103.23V164.62H0V103.23C0 74.3237 18.623 51.7593 49.0448 51.7593Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M383.519 164.62C386.607 164.62 389.513 164.403 392.234 163.968C394.956 163.534 398.981 162.375 400.159 161.796C396.768 155.549 394.45 151.281 393.203 148.99C389.87 142.862 387.971 139.383 387.5 138.553C385.757 138.77 384.504 138.77 383.738 138.553C382.592 138.227 380.318 137.358 378.774 136.272C377.23 135.186 375.979 133.701 375.023 131.819C374.067 129.936 373.588 127.474 373.588 124.433V114.752H343.985V124.867C343.985 136.784 347.655 146.303 354.51 153.425L354.943 153.867C362.077 161.036 371.603 164.62 383.519 164.62Z"
          fill="currentColor"
        />
        <path
          d="M479.057 155.434C484.117 155.434 488.22 151.321 488.22 146.248C488.22 141.174 484.117 137.061 479.057 137.061C473.998 137.061 469.896 141.174 469.896 146.248C469.896 151.321 473.998 155.434 479.057 155.434Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1525_9678">
          <rect
            width="500"
            height="166.667"
            fill="currentColor"
            transform="translate(0 0.57795)"
          />
        </clipPath>
      </defs>
    </svg>
  </div>
);
